import { pkceChallengeFromVerifier, stripOauthParamsFromUrl } from '../keycloack/authentication';

const keycloakServer = import.meta.env.VITE_PUBLIC_AUTH_KEYCLOAK_SERVER_URL;
const clientId = import.meta.env.VITE_PUBLIC_AUTH_KEYCLOAK_CLIENT_ID;
const realm = import.meta.env.VITE_PUBLIC_AUTH_KEYCLOAK_REALM;
const keycloakBaseUrl = `${keycloakServer}/auth/realms/${realm}/protocol/openid-connect`;
export const LOGOUT_DELETE_COOKIES_QUERY_PARAM = 'logout_delete_cookies';

export const createLoginURL = async (redirectUri: string, pkceCodeVerifier: string) => {
  const url = new URL(`${keycloakBaseUrl}/auth`);
  url.searchParams.append('client_id', clientId);
  url.searchParams.append('response_type', 'code');
  url.searchParams.append('redirect_uri', stripOauthParamsFromUrl(window.location.origin));
  url.searchParams.append('scope', 'openid');
  url.searchParams.append('code_challenge_method', 'S256');
  url.searchParams.append('code_challenge', await pkceChallengeFromVerifier(pkceCodeVerifier));
  return url.toString();
};

export const handleLoginCallback = async () => {
  const urlParams = new URLSearchParams(window.location.search);
  const authCode = urlParams.get('code');
  const pkceCodeVerifier = localStorage.getItem('pkceCodeVerifier');

  if (!authCode || !pkceCodeVerifier) {
    return null;
  }
  
  const tokenUrl = `${keycloakBaseUrl}/token`;
  const body = new URLSearchParams();
  body.append('grant_type', 'authorization_code');
  body.append('client_id', clientId);
  body.append('code', authCode);
  body.append('redirect_uri', stripOauthParamsFromUrl(window.location.origin)); 
  body.append('code_verifier', pkceCodeVerifier);

  try {
    const response = await fetch(tokenUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: body.toString(),
    });

    let data;
    try {
      data = await response.json();
    } catch (e) {
      console.warn("Could not parse the response as JSON. The response may be empty or not in JSON format.");
    }
    
    if (response.ok) {
      localStorage.removeItem('pkceCodeVerifier');
      return data;
    } else {
      return null;
    }
  } catch (error) {
    return null;
  }
};

export const refreshAccessToken = async (
  refreshToken: string,
  redirectUri: string,
) => {
  const url = `${keycloakBaseUrl}/token`;
  const body = new URLSearchParams();
  body.append('grant_type', 'refresh_token');
  body.append('client_id', clientId);
  body.append('refresh_token', refreshToken);
  body.append('redirect_uri', stripOauthParamsFromUrl(redirectUri));
  body.append('scope', 'openid offline_access')
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: body.toString(),
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(`Token refresh failed: ${errorData.error_description}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const buildLogoutUrl = (redirectUri: string, id_token_hint?: string) => {
  if (!id_token_hint) return '';
  const redirectUrl = new URL(redirectUri);
  redirectUrl.searchParams.append(LOGOUT_DELETE_COOKIES_QUERY_PARAM, 'true');
  const logoutUrl = new URL(`${keycloakBaseUrl}/logout`);
  logoutUrl.searchParams.append('client_id', clientId);
  logoutUrl.searchParams.append('id_token_hint', id_token_hint);
  logoutUrl.searchParams.append('post_logout_redirect_uri', redirectUrl.toString());
  return logoutUrl.toString();
};
